import { useState, useCallback } from 'react';

import { capitalizeFirstLetter } from '@libs/string';

const useManageViewSwitcher = (employeeName = '') => {
    const [viewType, setViewType] = useState('info');

    const baseTitle =
        viewType === 'info'
            ? 'Manage Employee Information'
            : `Manage ${capitalizeFirstLetter(viewType)}`;

    const selectedManageView = employeeName
        ? `${baseTitle} : (${employeeName})`
        : baseTitle;

    const handleManageViewChange = useCallback((value) => {
        setViewType(value);
    }, []);

    return { viewType, handleManageViewChange, selectedManageView };
};

export { useManageViewSwitcher };
